import React, { useEffect, useRef } from 'react';
import { Box, useTheme } from '@mui/material';
import { initMap, useMap } from '../../../state/map';
import MapCanvas from '../mapCanvas';
import MobileHeader from './MobileHeader';
import BottomBar from './BottomBar';
import { useAppDispatch } from '@/state/types';

const MobileMapMaker: React.FC = () => {
  const dispatch = useAppDispatch();
  const map = useMap();
  const mapDiv = useRef<HTMLDivElement>(null);
  const theme = useTheme();

  useEffect(() => {
    if (mapDiv.current) {
      dispatch(initMap(mapDiv.current));
    }
  }, [dispatch, mapDiv]);

  const handleCartClick = () => {
    // TODO: Implement cart/save functionality
    console.log('Cart clicked');
  };

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.default
      }}
    >
      {/* Mobile Header */}
      <MobileHeader onCartClick={handleCartClick} />

      {/* Map Container - Takes ~80% of screen */}
      <Box
        sx={{
          position: 'absolute',
          top: '72px', // Header height + 16px extra space
          left: 0,
          right: 0,
          bottom: '140px', // Bottom stepper bar height
          overflow: 'hidden',
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end"
        }}
      >
        <MapCanvas map={map} mapDiv={mapDiv} />
      </Box>

      {/* Bottom Bar with Stepper and Panels */}
      <BottomBar />
    </Box>
  );
};

export default MobileMapMaker;
